import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './auth.module';
import { globalUnitId } from './globalUnit.module';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        users: [],
        userRoles: [],
        userInfo: {},
        usersAccessibleUnits: [],
        selectedUnit: null,
        currentCensusPeriod: null,
    },
    modules: {
        auth,
        globalUnitId,
    }
});
